import React, { useEffect, useState } from 'react';
import utils from "../services/utils";
import managedata from "../services/managedata";
import LogViewer from "../comps/LogViewer";

const LogsHub = () => {
    const [logData, setLogData] = useState([]);
    const [filteredLogs, setFilteredLogs] = useState([]);
    const [actFilter, setActFilter] = useState("all");
    const [includeAllStatuses, setIncludeAllStatuses] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const getAllLogs = async () => {
        const isValid = false;
        if (!isValid) {
            const data = {
                authentication: {
                    key: utils.getToken(),
                    businessToken: utils.getBusToken(),
                },
                data: {},
                type: { act: 'searchLogs' }
            };

            try {
                const response = await managedata.sendData(data, false, 'sendBack');
                utils.saveSession('log-list', JSON.stringify(response.data));
                return response.data;
            } catch (err) {
                console.error(err);
                setError(err);
                return null;
            }
        } else {
            return isValid;
        }
    };

    const applyFilterAndSort = () => {
        let filtered = [...logData];

        if (!includeAllStatuses) {
            filtered = filtered.filter(log => log.statusCode === 100);
        }

        if (actFilter !== "all") {
            filtered = filtered.filter(log => log.act === actFilter);
        }

        if (searchTerm.trim()) {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(log => {
                const fullName = `${log.privateNameApprover || ''} ${log.lastNameApprover || ''}`.toLowerCase();
                return fullName.includes(term);
            });
        }

        if (fromDate) {
            const from = new Date(fromDate);
            filtered = filtered.filter(log => new Date(log.timestamp) >= from);
        }

        if (toDate) {
            const to = new Date(toDate);
            filtered = filtered.filter(log => new Date(log.timestamp) <= to);
        }

        return filtered.sort((a, b) => {
            const dateA = new Date(a.timestamp);
            const dateB = new Date(b.timestamp);
            if (dateA < dateB) return 1;
            if (dateA > dateB) return -1;
            const nameA = (a.privateNameApprover + a.lastNameApprover).toLowerCase();
            const nameB = (b.privateNameApprover + b.lastNameApprover).toLowerCase();
            return nameA.localeCompare(nameB);
        });
    };

    useEffect(() => {
        getAllLogs().then((data) => {
            if (data) {
                setLogData(data);
                setFilteredLogs(applyFilterAndSort());
            }
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        setFilteredLogs(applyFilterAndSort());
    }, [actFilter, includeAllStatuses, searchTerm, fromDate, toDate, logData]);

    const uniqueActs = Array.from(new Set(logData.map(log => log.act))).sort();

    if (loading) return <div>Loading logs...</div>;
    if (error) return <div>Error loading logs.</div>;

    return (
        <div className="p-4 space-y-6">
            {/* Filters */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
                {/* Act filter */}
                <div>
                    <label className="block font-medium mb-1">Filter by action:</label>
                    <select
                        value={actFilter}
                        onChange={(e) => setActFilter(e.target.value)}
                        className="border px-2 py-1 rounded w-full"
                    >
                        <option value="all">All Actions</option>
                        {uniqueActs.map((act, idx) => (
                            <option key={idx} value={act}>{act}</option>
                        ))}
                    </select>
                </div>

                {/* Status filter toggle */}
                <div>
                    <label className="block font-medium mb-1">Status:</label>
                    <div className="flex items-center space-x-2">
                        <input
                            type="checkbox"
                            checked={includeAllStatuses}
                            onChange={() => setIncludeAllStatuses(prev => !prev)}
                        />
                        <span>Include all statuses</span>
                    </div>
                </div>

                {/* Search bar */}
                <div>
                    <label className="block font-medium mb-1">Search approver name:</label>
                    <input
                        type="text"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="גל רונדל"
                        className="border px-2 py-1 rounded w-full"
                    />
                </div>

                {/* Date range */}
                <div className="flex space-x-2">
                    <div className="flex-1">
                        <label className="block font-medium mb-1">From:</label>
                        <input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            className="border px-2 py-1 rounded w-full"
                        />
                    </div>
                    <div className="flex-1">
                        <label className="block font-medium mb-1">To:</label>
                        <input
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            className="border px-2 py-1 rounded w-full"
                        />
                    </div>
                </div>
            </div>

            {/* Logs */}
            <ul className="space-y-2">
                {filteredLogs.length === 0 && (
                    <li className="text-gray-500 italic">No logs match current filters.</li>
                )}
                {filteredLogs.map((log, idx) => (
                    <LogViewer log={log} key={idx} index={idx} />
                ))}
            </ul>
        </div>
    );
};

export default LogsHub;
